<template>
  <v-dialog v-model="dialog" persistent width="500">
    <v-card>
      <ModalHeader
        title="Edit Benefit"
        icon="mdi-window-maximize"
        @close="dialog = false"
      />
      <v-card-text class="pa-4">
        <v-text-field
          label="Benefit Name"
          dense
          outlined
          v-model="item.name"
        ></v-text-field>
        <v-textarea
          label="Description"
          dense
          outlined
          v-model="item.description"
        ></v-textarea>
        <v-text-field
          label="Amount"
          dense
          outlined
          v-model="item.amount"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="submit" :loading="loading">Edit</v-btn>
        <v-btn @click="$emit('close')"> Close</v-btn>
        <v-spacer></v-spacer>
        <p class="caption grey--text">itemProfileModal.vue</p>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["item"],
  data() {
    return {
      dialog: true,
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      edit_benefit: "benefit/edit_benefit",
    }),

    async submit() {
      // confirm
      let x = await this.$confirm({
        title: "Edit Benefit",
        message: "Are you sure you want to edit this benefit?",
        color: "primary",
        icon: "mdi-pencil",
      });
      if (!x) return;
      this.loading = true;
      this.edit_benefit(this.item);
      this.$alert({
        title: "Success",
        message: "Successfully edited a benefit",
        color: "success",
        icon: "mdi-check-circle",
      });
      this.loading = false;
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped></style>
